import React, { useEffect, useState } from 'react'
import { CiEdit } from 'react-icons/ci'
import { useNavigate, useParams } from 'react-router-dom'
import { ConvertJalaliDate } from 'utilities/helper/digitToMonth'
import useGetMoneyPoolManagement from 'pages/fund/fundPage/hooks/useGetMoneyPoolManagement'

interface IItemProps {
    index: number
    jalaliDate: string
    amount: number
    isDelayed: boolean
    setIsOpen: React.Dispatch<React.SetStateAction<boolean>>
    setLoanAmount: React.Dispatch<React.SetStateAction<number | undefined>>
    isPayed: boolean
    setSelectedInstallment: React.Dispatch<
        React.SetStateAction<number | undefined>
    >
    id: number
    shouldShowPayButton: boolean
}

export default function Item({
    index,
    jalaliDate,
    amount,
    isDelayed,
    setIsOpen,
    setLoanAmount,
    isPayed,
    setSelectedInstallment,
    id,
    shouldShowPayButton,
}: IItemProps) {
    const { moneyPool } = useParams()
    const navigate = useNavigate()
    const { moneyPoolManagement } = useGetMoneyPoolManagement(moneyPool)
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        if (jalaliDate && amount) {
            setIsLoading(false)
        }
    }, [jalaliDate, amount])

    const handleEdit = () => {
        navigate(`edit/${id}`, {
            state: {
                amount: amount,
                number: index + 1,
            },
        })
    }

    const handlePayment = () => {
        setIsOpen(true)
        setSelectedInstallment(id)
        setLoanAmount(amount)
    }

    return (
        <div className="grid grid-cols-4 gap-2 p-3 bg-white w-full rounded-card shadow-card items-center text-xs">
            <div className="min-h-[50px] flex flex-col justify-center gap-1">
                {isLoading ? (
                    <div className="bg-divider rounded-md h-6 w-24 animate-pulse" />
                ) : (
                    <>
                        <p className="text-sm font-bold text-black">
                            قسط {index + 1}
                        </p>
                        <p className="text-xs text-text-secondary">
                            {ConvertJalaliDate(jalaliDate)}
                        </p>
                    </>
                )}
            </div>

            <div className="col-span-2 text-center">
                {isLoading ? (
                    <div className="bg-divider rounded-md h-6 w-full animate-pulse" />
                ) : (
                    <>
                        {isDelayed && !isPayed && (
                            <div className="bg-danger text-white rounded-md text-center w-12 py-0.5 mx-auto mb-1 text-xs font-bold">
                                معوق
                            </div>
                        )}
                        <p className="text-text-body">
                            مبلغ قسط:{' '}
                            <span className="font-bold text-black">
                                {amount?.toLocaleString()}
                            </span>{' '}
                            تومان
                        </p>
                    </>
                )}
            </div>

            <div className="text-center">
                {isPayed ? (
                    <div className="inline-flex items-center justify-center bg-success-2 text-success-on py-1 px-2 rounded-md text-xs">
                        پرداخت شده
                    </div>
                ) : (
                    <div className="flex justify-center items-center my-2">
                        {(moneyPoolManagement?.poolship?.role === 'mgr' ||
                            moneyPoolManagement?.poolship?.role === 'own') && (
                            <CiEdit
                                className="text-xl cursor-pointer text-text-secondary hover:text-green-1"
                                onClick={handleEdit}
                            />
                        )}
                    </div>
                )}

                {shouldShowPayButton && (
                    <button
                        className="bg-green-1 text-white py-1.5 px-2 rounded-card font-bold w-full shadow-fab active:scale-[0.98] transition-transform"
                        onClick={handlePayment}
                    >
                        پرداخت
                    </button>
                )}
            </div>
        </div>
    )
}
